import React from "react";
import ExportJobs from "../../ExportJobs/ExportJobs";

const ExportJobsdiv = () => {
  return <ExportJobs />;
};

export default ExportJobsdiv;
